// src/redux/reducers/menuManageReducer.js

import { combineReducers } from "redux";

import burgerSlice from "../slice/menu-manage-slice/burger-slice";
import dessertSlice from "../slice/menu-manage-slice/dessert-slice";
import drinkSlice from "../slice/menu-manage-slice/drink-slice";
import fishChipsSlice from "../slice/menu-manage-slice/fish-chips";
import kebabSlick from "../slice/menu-manage-slice/kebab-slice";
import pizzaSlice from "../slice/menu-manage-slice/pizza-slice";
import standardFoodSlice from "../slice/menu-manage-slice/standard-food-slice";
import teaCoffeeSlice from "../slice/menu-manage-slice/tea-coffee-slice";
import comboMealSlice from "../slice/menu-manage-slice/combo-meal-slice";
import mixAndMatchSlice from "../slice/menu-manage-slice/mix-and-match-slice";
import menuSlice from "../slice/menu-manage-slice/menu-slice";
import coursesSlice from "../slice/menu-manage-slice/courses-slice";
import createYourOwnGeneralSlice from "../slice/menu-manage-slice/create-your-own-general-slice";

// special menu
import dishDaySlice from "../slice/menu-manage-slice/special-menu/dish-of-the-day-slice";
import banquetSlice from "../slice/menu-manage-slice/special-menu/banquet-slice";
import buffetSlice from "../slice/menu-manage-slice/special-menu/buffets-slice";
import christmasSlice from "../slice/menu-manage-slice/special-menu/christmas-lunches-slice";
import partySlice from "../slice/menu-manage-slice/special-menu/party-platters-slice";
import sundayRoastSlice from "../slice/menu-manage-slice/special-menu/sunday-roast-slice";

const menuManageReducer = combineReducers({
  burger: burgerSlice,
  dessert: dessertSlice,
  drink: drinkSlice,
  fishChips: fishChipsSlice,
  kebab: kebabSlick,
  pizza: pizzaSlice,
  standardFood: standardFoodSlice,
  teaCoffee: teaCoffeeSlice,
  course: coursesSlice,
  menu: menuSlice,
  comboMeal: comboMealSlice,
  mixAndMatch: mixAndMatchSlice,
  createYourOwnGeneral: createYourOwnGeneralSlice,

  // special menu
  dishTheDay: dishDaySlice,
  banquet: banquetSlice,
  buffet: buffetSlice,
  christmas: christmasSlice,
  party: partySlice,
  sundayRoast: sundayRoastSlice,
});

export default menuManageReducer;
